module.exports = __webpack_public_path__ + "img/mypage_banner_02.52cd1396.png";